import { useEffect } from "react";
import useDb from "./useDb";
import { unflatten } from 'flat';

const useCachedForm = ({
  appointmentId,
  type,
  version,
  reset,
  defaultValues,
  isMounted
}) => {
  const db = useDb();

  const cacheFormValues = async (name, value) => {
    if (isMounted) {
      try {
        return db.transaction('rw', db.forms, () => db.forms
          .where({
            appointmentId,
            type,
            version,
          })
          .modify({ [name]: value }));
      }
      catch (err) {
        console.log(err)
      }
    }
  };

  useEffect(() => {
    db.transaction('rw', db.forms, () => db.forms.get({ appointmentId, type, version }).then((form) => {
      if (form) {
        reset(form)
        return db.forms.update({ appointmentId, type, version }, { reviewed: 0 });
      } else {
        return db.forms.add({
          ...unflatten(defaultValues),
          appointmentId,
          type,
          version,
          reviewed: 0,
        });
      }
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { cacheFormValues };
};

export default useCachedForm;
